import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDigitsOnly]',
})
export class DigitsOnlyDirective {
  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    const inputReplaceValue = inputValue ? inputValue.replace(/\D/g, '') : null;

    if (!inputValue || inputReplaceValue === input.value) {
      return;
    }

    // Присваиваем отфильтрованное значение обратно в поле ввода
    input.value = inputReplaceValue;
    // Обновляем значение и статус валидности контрола
    input.dispatchEvent(new Event('input'));
  }
}
